import request from './adminRequest'

export const questionApi = {
  listQuestion (params) {
    return request.get('/questions', { params: params })
  },
  deleteQuestion (id) {
    return request.delete('/questions/' + id)
  },
  getQuestion (id) {
    return request.get('/questions/' + id)
  },
  createQuestion (data) {
    return request.post('/questions', data)
  },
  updateQuestion (questionId, data) {
    return request.put('/questions/' + questionId, data)
  },
  getFilterOptions (params) {
    return request.get('/questions/filter-options', { params })
  },
}
export default questionApi
